import React, { useState, useMemo, useEffect } from "react";
import "../scss/button.scss";
import "../scss/EnachMandate.scss";
// import { ReactComponent as WarningIcon } from "../images/warning-icon.svg";
import { ReactComponent as Enach } from "../images/enach.svg";
import { ReactComponent as Upi } from "../images/upi.svg";
import { ReactComponent as MoneyIn } from "../images/moneyin.svg";
import { ReactComponent as Calender } from "../images/calender.svg";
import { ReactComponent as NoMoney } from "../images/nomoney.svg";
import { ReactComponent as Shield } from "../images/shield-green.svg";
import { ReactComponent as GreenCheckIcon } from "../images/check-greeen.svg";
import { ReactComponent as StarfinLogo } from "../images/stashfin-logo.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import { generateChecksum } from "../lib/middleware/generateChecksum";
import {
  setPageError,
  setIfscBankDetails,
} from "../lib/features/eligibilitySlice";
import {
  useSetUpAutopayMutation,
  useGetBankMandateMutation,
  useGetLoanbankDetailsMutation,
  useDobMatchMutation,
  useDobUpdateMutation,
} from "../lib/services/eligibilityApi";
import DOBPopup from "../components/popups/DOBPopup";

import { useDispatch, useSelector } from "react-redux";

function UpiMandate() {
  const location = useLocation();
  const [getLoanbankDetails] = useGetLoanbankDetailsMutation();
  // const [checked, setChecked] = useState(false);
  const [isUpi, setIsUpi] = useState(true);
  const [setUpAutopay] = useSetUpAutopayMutation();
  const [getBankMandate] = useGetBankMandateMutation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showDOBPopup, setShowDOBPopup] = useState(false);
  const [dob, setDob] = useState("");
  const [dobError, setDobError] = useState("");
  const [dobMatch] = useDobMatchMutation();
  const [dobUpdate] = useDobUpdateMutation();
  const [isDobVerified, setIsDobVerified] = useState(false);
  const [mandateOptions, setMandateOptions] = useState({upi: "", nach: ""})
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  // const device_id = useMemo(() => queryParams.get('device_id'), [queryParams])
  const utmSource = useMemo(() => queryParams.get("utm_source"), [queryParams]);
  const jwt = useMemo(() => queryParams.get("jwt_token"), [queryParams]);
  const secret = useMemo(() => queryParams.get("secret"), [queryParams]);
  const deviceid = useMemo(() => queryParams.get("device_id"), [queryParams]);
  const { partnerLocDetails, pageerror, ifscBankDetails } = useSelector(
    (state) => state.eligibility
  );

  const handleOpen = () => {
    setIsModalOpen(true);
  };

  let jwt_token;
  if (jwt) {
    jwt_token = jwt;
    localStorage.setItem("jwt", jwt);
  } else {
    jwt_token = localStorage.getItem("jwt");
  }
  const device_id = useMemo(() => queryParams.get("device_id"), [queryParams]);
  const scrt = secret ? secret : localStorage.getItem("secret");

  const getEnach = () => {
    const url = `${process.env.REACT_APP_API_URL}/v2/api/?webdebug=nachs`;

    const headers = {
      secret: scrt,
      "Content-Type": "application/x-www-form-urlencoded",
    };

    const body = {
      mode: "get_customer_details",
      pan_number: "",
    };
    const checksum = generateChecksum(body);

    fetch(url, {
      method: "POST",
      headers: headers,
      body: new URLSearchParams({ ...body, checksum }).toString(),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.redirect_url) {
          window.location.href = data.redirect_url;
        } else {
          setPageError(data.error);
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  const Setupautopay = async () => {
    try {
      const requestData = {};
      let jwt_token;
      if (jwt) {
        jwt_token = jwt;
        localStorage.setItem("jwt", jwt);
      } else {
        jwt_token = localStorage.getItem("jwt");
      }
      const scrt = secret ? secret : localStorage.getItem("secret");
      //const result = await loanSummary({ ...requestData, jwt_token, scrt, device_id })
      const result = await setUpAutopay({
        ...requestData,
        jwt_token,
        scrt,
        utmSource,
      });
      if (result.data && result.data.status === "error") {
        dispatch(setPageError(result.data.message));
        if (result.data.message === "Login expired! Please re-login.") {
          localStorage.removeItem("jwt");
          localStorage.removeItem("lastVisitedPage");
          const phone = localStorage.getItem("phone");
          localStorage.clear();
          phone ? navigate(`/?phone=${phone}`) : navigate("/");
        }
        handleOpen();
      } else if (
        result.data &&
        result.data.message === "Login expired! Please re-login."
      ) {
        dispatch(setPageError(result.data.message));
        localStorage.removeItem("jwt");
        localStorage.removeItem("lastVisitedPage");
        const phone = localStorage.getItem("phone");
        localStorage.clear();
        phone ? navigate(`/?phone=${phone}`) : navigate("/");
      } else if (result.error) {
        dispatch(
          setPageError("Please check your internet or try again later.")
        );
        handleOpen();
      } else {
        setMandateOptions({
          upi: result.data.landing_page_upi || "",
          nach: result.data.landing_page_nach || "",
        });
        // window.location.href = result.data.redirect_url;
      }
    } catch (error) {
      dispatch(setPageError("Something went wrong. Please try again later."));
      handleOpen();
    }
  };

  useEffect(() => {
    Setupautopay();
  },[]);

  const GetBankInfo = async () => {
    try {
      //const requestData = {};
      let jwt_token;
      if (jwt) {
        jwt_token = jwt;
        localStorage.setItem("jwt", jwt);
      } else {
        jwt_token = localStorage.getItem("jwt");
      }
      //requestData.ifsc = "KKBK0005311";
      const scrt = secret ? secret : localStorage.getItem("secret");
      //const result = await getbankdetail({ ...requestData, jwt_token, scrt });
      const result = await getLoanbankDetails({
        jwt_token,
        scrt,
        utmSource,
        deviceid,
      });
      if (result.data && result.data.status === "error") {
        dispatch(setPageError(result.data.message));
        if (result.data.message === "Login expired! Please re-login.") {
          localStorage.removeItem("jwt");
          localStorage.removeItem("lastVisitedPage");
          const phone = localStorage.getItem("phone");
          phone ? navigate(`/?phone=${phone}`) : navigate("/");
        }
      } else if (
        result.data &&
        result.data.message === "Login expired! Please re-login."
      ) {
        dispatch(setPageError(result.data.message));
        localStorage.removeItem("jwt");
        localStorage.removeItem("lastVisitedPage");
        const phone = localStorage.getItem("phone");
        phone ? navigate(`/?phone=${phone}`) : navigate("/");
      } else if (result.error) {
        dispatch(
          setPageError(
            result?.error?.data?.error_message ||
              result?.error?.data?.message ||
              "Please check your internet or try again later."
          )
        );
        // handleErrorModalOpen();
      } else {
        dispatch(setIfscBankDetails(result.data));
        // setShowPopup(true);

        // window.location.href = result.data?.data.redirect_url
      }
    } catch (error) {
      dispatch(setPageError("Something went wrong. Please try again later."));
      //   handleErrorModalOpen();
    }
  };

  const checkDOBMatch = async () => {
    try {
      const response = await dobMatch({
        jwt_token,
        scrt,
      });

      if (response.error) {
        dispatch(
          setPageError(
            response?.error?.data?.error_message ||
              response?.error?.data?.message ||
              "Please check your internet or try again later."
          )
        );
      } else if (response.data && response.data.status === "error") {
        dispatch(setPageError(response.data.message));
        if (response.data.message === "Login expired! Please re-login.") {
          localStorage.removeItem("jwt");
          localStorage.removeItem("lastVisitedPage");
          const phone = localStorage.getItem("phone");
          phone ? navigate(`/?phone=${phone}`) : navigate("/");
        }
      } else {
        if (!response.data.data.dob_match) {
          setShowDOBPopup(true);
          setIsDobVerified(false);
          return false;
        } else {
          setShowDOBPopup(false);
          setIsDobVerified(true);
          return true;
        }
      }
    } catch (error) {
      dispatch(setPageError("Something went wrong. Please try again later."));
    }
  };

  const handleDobChange = (value) => {
    setDob(value);
    if (dobError) {
      setDobError("");
    }
  };

  // Function to validate if a date is valid
  const isValidDate = (dateString) => {
    // Check if format is DD/MM/YYYY
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegex.test(dateString)) {
      return false;
    }

    const [day, month, year] = dateString.split("/").map(Number);

    // Basic range checks
    if (year < 1900 || year > new Date().getFullYear()) {
      return false;
    }
    if (month < 1 || month > 12) {
      return false;
    }
    if (day < 1 || day > 31) {
      return false;
    }

    // Create date object to check if date is valid
    const date = new Date(year, month - 1, day);
    return (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    );
  };

  // Function to parse API error messages
  const parseApiError = (errorResponse) => {
    try {
      // Check if error_message exists and is a string
      if (errorResponse?.data?.error_message) {
        const errorMessage = errorResponse.data.error_message;

        // Try to parse as JSON if it's a string
        if (typeof errorMessage === "string") {
          try {
            const parsedErrors = JSON.parse(errorMessage);
            if (Array.isArray(parsedErrors) && parsedErrors.length > 0) {
              return parsedErrors[0].message || "Invalid data provided";
            }
          } catch (e) {
            // If JSON parsing fails, return the string as is
            return errorMessage;
          }
        }
        return errorMessage;
      }

      // Fallback to other error fields
      return errorResponse?.data?.message || "An error occurred";
    } catch (e) {
      return "An error occurred";
    }
  };

  const updateDOB = async (dobValue) => {
    try {
      // Convert DD/MM/YYYY to YYYY-MM-DD format
      const [day, month, year] = dobValue.split("/");
      const apiDob = `${year}-${month}-${day}`;

      const response = await dobUpdate({
        dob: apiDob,
        jwt_token,
        scrt,
      });

      if (response.error) {
        // Use the new error parsing function for better error messages
        const errorMessage = parseApiError(response.error);
        setDobError(errorMessage);
        return false;
      } else if (response.data && response.data.status === "error") {
        setDobError(response.data.message);
        if (response.data.message === "Login expired! Please re-login.") {
          localStorage.removeItem("jwt");
          localStorage.removeItem("lastVisitedPage");
          const phone = localStorage.getItem("phone");
          phone ? navigate(`/?phone=${phone}`) : navigate("/");
        }
        return false;
      } else {
        return true;
      }
    } catch (error) {
      setDobError("Failed to update DOB");
      return false;
    }
  };

  const handleDOBConfirm = async () => {
    // Clear any existing errors
    setDobError("");

    // Basic format validation
    if (!dob || dob.length !== 10) {
      setDobError("Please enter a valid DOB in DD/MM/YYYY format");
      return;
    }

    // Advanced date validation
    if (!isValidDate(dob)) {
      setDobError("Please enter a valid date in DD/MM/YYYY format");
      return;
    }

    // Check if user is at least 18 years old
    const [day, month, year] = dob.split("/").map(Number);
    const userDate = new Date(year, month - 1, day);
    const today = new Date();
    const age = today.getFullYear() - userDate.getFullYear();
    const monthDiff = today.getMonth() - userDate.getMonth();
    const dayDiff = today.getDate() - userDate.getDate();

    const actualAge =
      monthDiff < 0 || (monthDiff === 0 && dayDiff < 0) ? age - 1 : age;

    if (actualAge < 18) {
      setDobError("You must be at least 18 years old");
      return;
    }

    if (actualAge > 100) {
      setDobError("Please enter a valid date of birth");
      return;
    }

    const success = await updateDOB(dob);
    if (success) {
      await checkDOBMatch();
    }
  };

  useEffect(() => {
    GetBankInfo();
    checkDOBMatch();
  }, []);
  return (
    <div className="external-wrapper">
      <div className="page-content mandate-page">
        <PageHeader />
      </div>
      <div className="body">
        <h1 style={{ marginTop: 0 }}>
          Set up auto pay
        </h1>
        <div className="whybox">
          <div className="title">Why is this required?</div>
          <div className="subtitle">
            This step is only to authorize UPI auto pay.
          </div>
          <div>
            <div>
              <NoMoney />
              <p>No money deduction now</p>
            </div>
            <div>
              <MoneyIn />
              <p>EMI debits only when due</p>
            </div>
            <div>
              <Calender />
              <p>Never miss a due date</p>
            </div>
          </div>
        </div>
        {ifscBankDetails && (
          <div className="box">
            <div className="detailsContainer">
              <p className="accountNumber">Account Number</p>{" "}
              {/* {"customerBankDetails?.ifsc_code"} */}
              <div>
                <span>XXXX XXXX {ifscBankDetails.account_no.slice(-4)}</span>
                <GreenCheckIcon className="greenIcon" />
              </div>
            </div>
            <div className="divider" />
            <div className="detailsContainer">
              <p className="accountNumber">Bank Name</p>{" "}
              {/* {"customerBankDetails?.ifsc_code"} */}
              <div>
                <span>{ifscBankDetails.bank_name}</span>{" "}
                {/* {"customerBankDetails?.account_number"} */}
                <GreenCheckIcon />
              </div>
            </div>
          </div>
        )}
        <div className="setupmandate">Set up mandate to get funds</div>
        <div className="moneyDeduction">
          Do not worry, there is no money deduction
        </div>
        <div className="datasafety">
          <Shield /> 100% safe & secure
        </div>
        <div className="bottom-footer">
          <p className="powered-by">
            {" "}
            Powered by <StarfinLogo />{" "}
          </p>
          {mandateOptions.upi ? (
            <button
              type="button"
              className="btn btn-primary"
              style={{margin: "10px 0"}}
              onClick={() => {
                setIsUpi(true);
                window.location.href = mandateOptions.upi;
              }}
            >
              Set up via UPI
            </button>
          ) : null}
          {mandateOptions.nach ? (
            <button
              type="button"
              className="btn btn-primary-outlined"
              style={{margin: "10px 0"}}
              onClick={() => {
                setIsUpi(false);
                window.location.href = mandateOptions.nach;
              }}
            >
              Set up via Net Banking / Debit Card / Aadhaar
            </button>
          ) : null}
        </div>
      </div>
      <DOBPopup
        isOpen={showDOBPopup}
        dob={dob}
        onChange={handleDobChange}
        onClose={() => setShowDOBPopup(false)}
        onConfirm={handleDOBConfirm}
        pageerror={dobError}
      />
    </div>
  );
}

export default UpiMandate;
